import React from "react";
import { Modal, Tag, Divider } from "antd";

const OfferDetailsModal = ({
  offerDetailsOpen,
  setOfferDetailsOpen,
  selectedOffer,
  modalTagMeta,
  formatDate,
  getDiscountText,
  getApplicableDays,
}) => {
  return (
    <Modal open={offerDetailsOpen} footer={null} width={450} height={450} centered onCancel={() => setOfferDetailsOpen(false)}>
      {selectedOffer && (
        <>
          {/* HEADER */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 12,
            }}
          >
            <h3 style={{ fontWeight: 600, margin: 0 }}>{selectedOffer.printedName || selectedOffer.name}</h3>

            <Tag
              style={{
                background: modalTagMeta.color,
                color: "#fff",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                gap: 2,
                padding: "4px 10px",
                fontSize: 10,
                fontWeight: 500,
              }}
            >
              {modalTagMeta.icon}
              <span>{modalTagMeta.label}</span>
            </Tag>
          </div>

          {/* DESCRIPTION */}
          {selectedOffer.description && <p style={{ color: "#6b7280", fontSize: 12, marginTop: 6 }}>{selectedOffer.description}</p>}

          {/* DETAILS GRID */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 12,
              fontSize: 12,
              marginTop: 12,
            }}
          >
            <div>
              <div style={{ color: "#6b7280", fontWeight: 500 }}>Offer Type</div>
              <div style={{ fontWeight: 500 }}>{selectedOffer.name}</div>
            </div>

            <div>
              <div style={{ color: "#6b7280", fontWeight: 500 }}>Discount</div>
              <div style={{ color: "#10b981", fontWeight: 500 }}>{getDiscountText(selectedOffer)}</div>
            </div>

            <div>
              <div style={{ color: "#6b7280", fontWeight: 500 }}>Valid From</div>
              <div style={{ fontWeight: 500 }}>{formatDate(selectedOffer.startDate)}</div>
            </div>

            <div>
              <div style={{ color: "#6b7280", fontWeight: 500 }}>Valid Until</div>
              <div style={{ fontWeight: 500 }}>{formatDate(selectedOffer.endDate)}</div>
            </div>
          </div>

          {/* APPLICABLE ON */}
          {/* APPLICABLE ON */}
          <div style={{ marginTop: 14, fontSize: 12 }}>
            <b>Applicable On</b>

            <div
              style={{
                marginTop: 6,
                display: "flex",
                flexWrap: "wrap",
                gap: 6,
              }}
            >
              {getApplicableDays(selectedOffer).map((day) => (
                <Tag
                  key={day}
                  style={{
                    borderRadius: 8,
                    fontSize: 11,
                    padding: "2px 8px",
                  }}
                >
                  {day}
                </Tag>
              ))}
            </div>
          </div>

          <Divider />

          {/* TERMS */}
          <span style={{ fontSize: 14, fontWeight: 500 }}>Terms & Conditions</span>

          <p
            style={{
              fontSize: 12,
              color: "#6b7280",
              marginTop: 8,
              lineHeight: "18px",
            }}
          >
            {"Standard terms apply."}
          </p>

          {/* FOOTER NOTE */}
          <div
            style={{
              marginTop: 16,
              padding: 12,
              background: "#f9fafb",
              borderRadius: 8,
              fontSize: 13,
              color: "#6b7280",
            }}
          >
            ⚠ This is for informational purposes only. Offers are applied automatically at checkout.
          </div>
        </>
      )}
    </Modal>
  );
};

export default OfferDetailsModal;
